import { FIELD_TYPES } from 'src/tpbp-core/models/fields/field-set.const'
import { OBJECT_TYPES } from 'src/tpbp-configuration/models/models.const'
import type {
  FieldInterface,
  RelationInterface,
} from 'src/tpbp-configuration/mapper/mappingInterfaces'

const legConfigurationFields: FieldInterface[] = [
  {
    key: 'attributionTypes',
    originKey: 'attribution_types',
    type: FIELD_TYPES.object,
    objectType: 'LabelValueType',
    objectTypePath: 'src/tpbp-core/models/common.const',
    isMultiple: true,
  },
]

const legConfigurationRelations: RelationInterface[] = [
  {
    key: '_attributors',
    originKey: 'attributors',
    objectType: OBJECT_TYPES.attributorsConfiguration,
  },
  {
    key: '_receivers',
    originKey: 'receivers',
    objectType: OBJECT_TYPES.receiversConfiguration,
  },
]

export { legConfigurationFields, legConfigurationRelations }
